import { MantineProvider } from "@mantine/core"
import { ReactNode } from "react"

export const ThemeWrapper = ({ children }: { children: ReactNode }) => (
  <MantineProvider
    theme={{
      fontFamily: "'Open Sans', sans-serif",
      headings: { fontFamily: "'Playfair Display', serif" },
    }}
    defaultProps={{
      Container: {
        sizes: {
          xs: 540,
          sm: 720,
          md: 972,
          lg: 1140,
          xl: 1320,
        },
      },
    }}
  >
    {children}
  </MantineProvider>
)
